var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-company-drive",attrs:{"id":"idModalFtp"}},[_c('div',{staticClass:"wrap-content"},[_c('button',{on:{"click":function($event){_vm.$emit('close-popup', null)}}},[_vm._v("close")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a167db9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/ModalFtp.vue
// module id = null
// module chunks = 